import { render, staticRenderFns } from "./MessageManage.vue?vue&type=template&id=b72a0ff8&scoped=true"
import script from "./MessageManage.vue?vue&type=script&lang=js"
export * from "./MessageManage.vue?vue&type=script&lang=js"
import style0 from "./MessageManage.vue?vue&type=style&index=0&id=b72a0ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72a0ff8",
  null
  
)

export default component.exports